import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import Swal from "sweetalert2";
import {
    RenderNumber,
    RenderKilogramo,
} from "Utils/renderField/renderReadField";
import LoadMask from "Utils/LoadMask/LoadMask";
import { BoletaTrasladoApi } from "./api/BoletaTrasladoApi";
import { DetallesTable } from "./DetallesTable";
import { DetallesSobranteTable } from "./DetallesSobranteTable";
import { getErrorFromResponse } from "../../../../../../../utility/utils";
const logo_img = require("assets/img/logo.png");
const produccion_activo = require(`assets/img/icons/produccion_activo.png`);
const linea_img = require("assets/img/icons/linea.png");

export const DatosBoleta = ({ trasladoId }) => {
    const fechaHoraImpresion = moment().format("DD/MM/YYYY HH:mm:ss");

    const { getTraslado, cargando: cargandoDetalle } = BoletaTrasladoApi();

    const [trasladoDetalle, setTrasladoDetalle] = useState({});

    const GetTrasladoDetalle = async () => {
        try {
            const data = await getTraslado(trasladoId);
            setTrasladoDetalle(data);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el detalle del traslado",
            );
            Swal.fire({
                title: "Error",
                text: errorMsg,
                type: "error",
            });
            setTrasladoDetalle({});
        }
    };

    useEffect(() => {
        GetTrasladoDetalle();
    }, [trasladoId]);

    if (cargandoDetalle) {
        return (
            <LoadMask loading={cargandoDetalle} blur>
                <div style={{ height: "400px" }}></div>
            </LoadMask>
        );
    }

    return (
        <div className="col-12 p-0">
            <div className="row contenido-impresion verde-secundario d-flex justify-content-center">
                <div className="col-12 row">
                    <div className="col-12 d-flex justify-content-center mt-0 mb-3">
                        <div className="col-11 pl-2">
                            <div className="row col-12 p-0 mt-3 d-flex justify-content-between align-items-center">
                                <img
                                    className="d-inline-block align-top"
                                    src={logo_img}
                                    alt="Logo"
                                    height="50px"
                                />
                                <label className="p-0 m-0">
                                    ACOPIO ERSA KM. 7.5 CARRETERA A TULATE
                                </label>
                                <div className="ml-4 mr-4"></div>
                            </div>
                        </div>
                    </div>
                    {/* DATOS TRASLADO */}
                    <div className="col-12 d-flex justify-content-center mt-0">
                        <div className="col-11">
                            <div className="row col-12 p-0 mt-2 mb-3 align-items-start">
                                <div className="col-12 p-0 fondo">
                                    <div className="col-12 d-flex flex-column pl-0">
                                        <div className="d-flex align-items-center">
                                            <img
                                                src={produccion_activo}
                                                alt="Usuario"
                                                className="title_img mr-2"
                                            />
                                            <img
                                                src={linea_img}
                                                alt="Linea"
                                                className="title_img mr-2"
                                            />
                                            <h6 className="text-black mb-0">
                                                Boleta de traslado control de
                                                calidad conforme/no conforme
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row col-12 p-0 py-2">
                                <div className="col-7 p-0 d-flex align-items-center">
                                    <div className="col-12 d-flex align-items-baseline">
                                        <label className="p-0 m-0">
                                            NÚMERO DE TRASLADO
                                        </label>
                                        <h5 className="gris bold pl-2 mb-0">
                                            {trasladoDetalle.numero}
                                        </h5>
                                    </div>
                                </div>
                                <div className="col-5 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <span className="gris">
                                            Fecha de impresión:
                                        </span>
                                        <span className="gris">
                                            {fechaHoraImpresion}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="row col-12 p-0 pt-1">
                                <div className="col-7 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <label className="p-0 m-0">
                                            FECHA DE TRASLADO
                                        </label>
                                        <span className="gris">
                                            {trasladoDetalle.fecha_con_desfase
                                                ? moment(
                                                      trasladoDetalle.fecha_con_desfase,
                                                  ).format(
                                                      "DD/MM/YYYY - HH:mm",
                                                  )
                                                : ""}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-5 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <label className="p-0 m-0">TURNO</label>
                                        <span className="gris">
                                            {trasladoDetalle.fecha_con_desfase &&
                                            moment(
                                                trasladoDetalle.fecha_con_desfase,
                                            ).hour() < 18
                                                ? "Diurno"
                                                : "Nocturno"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="row col-12 p-0 mt-2">
                                <div className="col-7 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <label className="p-0 m-0">
                                            TIPO DE TRASLADO
                                        </label>
                                        <span className="gris">
                                            {
                                                trasladoDetalle.tipo_traslado_display
                                            }
                                        </span>
                                    </div>
                                </div>
                                <div className="col-5 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <label className="p-0 m-0">
                                            CANTIDAD DE PALLETS
                                        </label>
                                        <span className="gris">
                                            <RenderNumber
                                                value={
                                                    trasladoDetalle.total_pallets
                                                }
                                                decimalScale={0}
                                            />
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="row col-12 p-0 mt-2">
                                <div className="col-7 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <label className="p-0 m-0">
                                            CANTIDAD DE PACAS TRASLADADAS
                                        </label>
                                        <span className="gris">
                                            <RenderNumber
                                                value={
                                                    trasladoDetalle.total_pacas_trasladadas
                                                }
                                                decimalScale={0}
                                            />
                                        </span>
                                    </div>
                                </div>
                                <div className="col-5 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <label className="p-0 m-0">
                                            KG SECOS SOBRANTES TRASLADADOS
                                        </label>
                                        <span className="gris">
                                            <RenderKilogramo
                                                value={
                                                    trasladoDetalle.total_kg_secos_trasladados
                                                }
                                                decimalScale={2}
                                            />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* TABLA DE DETALLES */}
                    <div className="col-12 d-flex justify-content-center p-0">
                        <div className="col-11 form-group np-r p-0 mt-3 mb-1">
                            <DetallesTable trasladoDetalle={trasladoDetalle} />
                            <DetallesSobranteTable
                                trasladoDetalle={trasladoDetalle}
                            />
                        </div>
                    </div>
                    {/* FIRMAS */}
                    <div className="my-2 w-100 h-auto"></div>
                    <div className="col-12 d-flex justify-content-center mt-5 p-0">
                        <div className="col-11">
                            <div className="row col-12 p-0 d-flex align-items-center">
                                <div className="col-6 p-0">
                                    <div className="col-12 d-flex flex-row align-items-end">
                                        <div className="col-6">
                                            <label className="p-0 m-0">
                                                FIRMA BODEGA
                                            </label>
                                        </div>
                                        <div className="col-6">
                                            <input
                                                className="espacio-firma mb-1"
                                                type="text"
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6 p-0">
                                    <div className="col-12 d-flex flex-row align-items-end">
                                        <div className="col-6">
                                            <label className="p-0 m-0">
                                                FIRMA CONTROL DE CALIDAD
                                            </label>
                                        </div>
                                        <div className="col-6">
                                            <input
                                                className="espacio-firma mb-1"
                                                type="text"
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 d-flex justify-content-center mt-5 mb-5">
                        <div className="col-11">
                            <div className="row col-12 p-0 mt-3">
                                <div className="col-8 p-0">
                                    <div className="col-12 d-flex flex-column"></div>
                                </div>
                                <div className="col-4 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <span className="gris">
                                            {/* TODO: Actualizar */}
                                            ERSA-F-GO-025-06
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
